import { client } from './client';

export const getEmployeeDetails = (token) => {
  return client(
    'me',
    {
      withCredentials: false,
      method: 'GET',
      params: {
        $select: 'displayName, userPrincipalName, employeeId'
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    },
    import.meta.env.VITE_MS_GRAPH_API
  );
};
